export default __webpack_public_path__ + "static/media/Interface.b6ba2965.mp3";